/* eslint-disable no-case-declarations */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import updateIdentityRegionaleActions, {
    updateIdentityRegionaleTypes,
} from '../../redux/identityRegionale/updateIdentityRegionale'
import { Put } from '../../serveur/axios'
import alertActions from '../../redux/alert'

function* updateIdentityRegionaleSagas({ response }) {
    try {
        const { id, intl } = response
        delete response.intl
        delete response.id
        const res = yield Put(`identityRegion/${id}`, response)
        if (res.status === 200 || res.status === 201 || res.status === 202) {
            yield all([
                yield put(
                    updateIdentityRegionaleActions.updateIdentityRegionaleSuccess(
                        res.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(
                updateIdentityRegionaleActions.updateIdentityRegionaleFailure(
                    res.data
                )
            )
        }
    } catch (error) {
        yield put(
            updateIdentityRegionaleActions.updateIdentityRegionaleFailure(error)
        )
    }
}

export function* updateIdentityRegionale() {
    yield takeLatest(
        updateIdentityRegionaleTypes.UPDATE_IDENTITY_REGIONALE_REQUEST,
        updateIdentityRegionaleSagas
    )
}
